import { createAction, props } from '@ngrx/store';
import { LogEntry, LogsResponse } from '../../shared/services/admin/logs.service';

export const loadLogs = createAction(
  '[Logs] Load Logs',
  props<{
    level?: string;
    source?: string;
    module?: string;
    logger_name?: string;
    page?: number;
    page_size?: number;
    limit?: number;
    offset?: number;
  }>(),
);

export const loadLogsSuccess = createAction(
  '[Logs] Load Logs Success',
  props<{ response: LogsResponse }>(),
);

export const loadLogsFailure = createAction('[Logs] Load Logs Failure', props<{ error: any }>());

export const clearLogs = createAction('[Logs] Clear Logs');
